import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { SharedService } from '../_service/shared.service';
import { TpaService } from '../_service/tpa.service';

@Component({
  selector: 'app-tpa',
  templateUrl: './tpa.component.html',
  styleUrls: ['./tpa.component.css']
})
export class TpaComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  pageSizeOptions = [10,25,50,100];perpage:number=25;pageIndex:number=0;tpaList:any=[];loaded:boolean=false;loading:boolean=true;length:number=0;pageEvent: PageEvent;search:string;status='';myrole:string;

  constructor(private tpa: TpaService, private sharedapi: SharedService) { }

  ngOnInit(): void {
    this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
  }

  ngAfterViewInit() {
    this.loadTpaList(0,this.perpage);
  }

  async loadTpaList(pageIndex,perpage)
    {
    	  this.tpaList = [];
        this.paginator.pageIndex = pageIndex;
    	  let qString = 'search='+this.search+'&status='+this.status;
        this.loading = true;this.loaded = false;
        this.tpa.gelAllTpa(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
        	this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.tpaList = data.data;
            }else{
                this.tpaList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadTpaList(event.pageIndex,event.pageSize);
    }

    onStatusChange(event,id,index){
      let status=0;
      if(event.checked) status=1;
      let value = {
          'id':id,
          'status':status
      }
      this.tpa.updateTpaStatus(value).subscribe((data:any) => {
          if(data.status)
          {
              this.sharedapi.presentToast('Status Update Successfully');
              this.tpaList[index].status=data.data.status;
          } else {
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });

  }

}
